/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanySearchDto
 */
export interface CompanySearchDto {
    /**
     * 
     * @type {string}
     * @memberof CompanySearchDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchDto
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchDto
     */
    city?: string | null;
}

/**
 * Check if a given object implements the CompanySearchDto interface.
 */
export function instanceOfCompanySearchDto(value: object): value is CompanySearchDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CompanySearchDtoFromJSON(json: any): CompanySearchDto {
    return CompanySearchDtoFromJSONTyped(json, false);
}

export function CompanySearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanySearchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'city': json['city'] == null ? undefined : json['city'],
    };
}

export function CompanySearchDtoToJSON(json: any): CompanySearchDto {
    return CompanySearchDtoToJSONTyped(json, false);
}

export function CompanySearchDtoToJSONTyped(value?: CompanySearchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'city': value['city'],
    };
}

